// import React from "react";
// import ReactDOM from "react-dom";
// import "./index.css";
// import { Provider } from "react-redux";
// import Store from "./redux/Store";
// import { PersistGate } from "redux-persist/integration/react";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// // import { LocalizationProvider } from './i18nLanguage/LocalizationContext';
// const persistStore = Store();

// ReactDOM.render(
//   <React.StrictMode>
//     <Provider store={persistStore.store}>
//       <PersistGate persistor={persistStore.persistor}>
//         <App />
//       </PersistGate>
//     </Provider>
//   </React.StrictMode>,
//   document.getElementById("root")
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import Store from "./redux/Store";

const persistStore = Store();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={persistStore.store}>
      <PersistGate persistor={persistStore.persistor}>
        <App />
       </PersistGate>
     </Provider>
   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
